<template>
    <div class="greybox">
        <h1>What you need to do next...</h1>
        <div v-html="selectedOptionInstructions" />
        <button class="button mt-3" @click="handleCancelClick()">OK</button>
    </div>
</template>
<script>
import repairOptionsBase from '@/mixins/repairOptionsBase'
export default {
  computed: {

  },
  mixins: [
    repairOptionsBase
  ],
  methods: {
    handleCancelClick () {
      // this.$router.push({ path: '/myclaims/repairoptions/cancel/' })
      this.$router.push({ path: '/myclaims/view/' + this.selectedClaim.id }) //if this is used anywhere other than after making a claim may need to make a check to stop  a null ref from happening 
    }
  }
}
</script>
